import { mergeMap } from './mergeMap';
export var flatMap = mergeMap;